import { LicenseManager } from 'ag-grid-enterprise';

export {
  RowHeightParams as AgGrid_RowHeightParams,
  IsFullWidthRowParams as AgGrid_IsFullWidthRowParams,
  ColDef as AgGrid_ColDef,
} from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(
  'Using_this_AG_Grid_Enterprise_key_( AG-047512 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Merlin Software )_is_granted_a_( Multiple Applications )_Developer_License_for_( 1 ))_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 1 )_Production_Environment___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 10 September 2024 )____[v2]_MTcyNTkyMjgwMDAwMA==dbc38a2a5c87693d4f32ae25d2116e49'
);
